import axios from "axios";

let installed = false;
let sequence = 0;
const pendingRequests = new Map();
const keyedRequests = new Map();

const removeRequest = config => {
  const requestId = config && config.__requestId;
  const cancelKey = config && config.cancelKey;

  if (requestId) pendingRequests.delete(requestId);
  if (cancelKey && keyedRequests.get(cancelKey)?.requestId === requestId) {
    keyedRequests.delete(cancelKey);
  }
};

export const installRequestCancellation = () => {
  if (installed) return;
  installed = true;

  axios.interceptors.request.use(config => {
    if (config.skipAutoCancel) return config;

    const requestId = `request-${++sequence}`;
    const source = axios.CancelToken.source();

    if (config.cancelKey && keyedRequests.has(config.cancelKey)) {
      const previousRequest = keyedRequests.get(config.cancelKey);
      pendingRequests.delete(previousRequest.requestId);
      previousRequest.source.cancel("Request digantikan oleh request terbaru.");
    }

    config.__requestId = requestId;
    config.cancelToken = source.token;
    pendingRequests.set(requestId, source);

    if (config.cancelKey) keyedRequests.set(config.cancelKey, { requestId, source });

    return config;
  });

  axios.interceptors.response.use(
    response => {
      removeRequest(response.config);
      return response;
    },
    error => {
      removeRequest(error.config);

      // A canceled request belongs to an obsolete page/state. Keeping it silent
      // prevents an old catch/finally block from updating the current screen.
      if (axios.isCancel(error)) return new Promise(() => {});

      return Promise.reject(error);
    }
  );
};

export const cancelPendingRequests = (message = "Navigasi ke halaman lain.") => {
  pendingRequests.forEach(source => source.cancel(message));
  pendingRequests.clear();
  keyedRequests.clear();
};
